import { render, staticRenderFns } from "./vat_header.vue?vue&type=template&id=50d87e40&scoped=true"
import script from "./vat_header.vue?vue&type=script&lang=js"
export * from "./vat_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d87e40",
  null
  
)

export default component.exports